export {default} from './ai-input.vue'